(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  const placeProductPageKeyPoints = (root = document) => {
    root.querySelectorAll('.product-information--main').forEach((section) => {
      const keyPoints = section.querySelector('.product-details > rte-formatter .product-key-points');
      const buyButtons = section.querySelector('.product-details > .buy-buttons-block');

      if (keyPoints && buyButtons) buyButtons.before(keyPoints);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => placeProductPageKeyPoints(), { once: true });
  } else {
    placeProductPageKeyPoints();
  }

  document.addEventListener('shopify:section:load', (event) => placeProductPageKeyPoints(event.target));

  } catch(e) { console.error(e); }
})();
})();
